const IDENTITY_FIELDS = ['user-email', 'company-name', 'company-role'];
const CHECKED_FIELDS = ['connection-status', 'license-status'];

/**
 * Puts the session card back to how it reads before anyone has signed in. The
 * ERP and License rows are filled only after several requests, so whatever the
 * card held stays on screen until then — after a sign-out that is the previous
 * account's company, ERP and plan.
 */
export function resetSessionCard(doc: Document = document): void {
  for (const id of IDENTITY_FIELDS) {
    const el = doc.getElementById(id);
    if (el) el.textContent = '';
  }
  for (const id of CHECKED_FIELDS) {
    const el = doc.getElementById(id);
    if (el) {
      el.textContent = 'Checking…';
      el.className = '';
    }
  }
}
